var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMindsetGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3404_1095",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3404_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.391 17.5V17.5C12.7353 16.8373 12.9947 16.1267 13.0609 15.3828C13.2654 13.0858 12.6357 11.6694 10.8323 9.50002C9.44649 8.03789 7.71503 6.50002 7.71503 6.50002",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.621 17.5848C13.6201 16.4057 14.1664 15.2643 15.1693 14.3932C15.8017 13.8438 16.6069 13.3595 17.5865 13",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27153 2.15134C5.27153 2.15134 10.5537 3.34796 11.889 4.40935C12.9942 5.28792 13.4759 6.30464 13.6513 7.22049C14.1538 9.84408 12.1384 12.1932 9.36557 12.2138C8.39789 12.2211 7.26944 11.9579 6.16421 11.0793C3.27341 8.78138 2.31085 4.83703 2.01159 3.02719C1.92479 2.50224 2.33623 2.02285 2.88828 2.00574C3.58153 1.98422 4.14195 2.02121 5.27153 2.15134Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.456 15.1468C21.0252 13.8274 21.7233 11.7573 21.983 10.7534C22.0656 10.4341 21.8383 10.1173 21.4988 10.0785C20.3281 9.94443 17.7244 9.8303 15.8141 11.0994C15.0838 11.5846 14.7304 12.187 14.5715 12.7429C14.1162 14.3353 15.2293 15.8876 16.9384 16.0426C17.3682 16.0815 19.1451 15.5 19.456 15.1468Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1842 22C19.3183 20.6667 16.5474 17.5 12.391 17.5C7.19548 17.5 4.07819 21.5 4.07819 22",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindsetGrowth);
export default __webpack_public_path__ + "static/media/mindset-growth.b2a090d51970068ed2bcc9f80bd3aec9.svg";
export { ForwardRef as ReactComponent };